import { fingerFor, type Bundle, type Lesson } from "@otto/lehrgang";
import { cssVar } from "../../../shared/lib/cssVar.js";
import styles from "./practice.module.css";
import own from "./LessonIntro.module.css";

/**
 * Eine Kachel je Taste, nicht je Zeichen.
 *
 * Groß und klein sind dieselbe Taste. Lehrt die Lektion die Großschreibung,
 * zeigt die Kachel den Großbuchstaben – das ist an ihr das Neue. Ohne das
 * stünden in Kapitel 5 zweiundzwanzig Kacheln für elf Tasten.
 */
function tilesFor(lesson: Lesson): string[] {
  const keys = lesson.keys.filter((key) => key !== " ");
  return [...new Set(keys.map((key) => key.toLowerCase()))].map((base) =>
    keys.includes(base.toUpperCase()) ? base.toUpperCase() : base,
  );
}

/** What the child sees before typing: the keys of this lesson, large and coloured. */
export function LessonIntro({
  bundle,
  lesson,
  onStart,
}: {
  bundle: Bundle;
  lesson: Lesson;
  onStart: () => void;
}) {
  return (
    <div className={styles.card}>
      <h2 className={own.heading2}>Bevor du lostippst …</h2>
      <p className={own.text}>{lesson.intro}</p>

      <div className={own.homeRow}>
        {tilesFor(lesson).map((key) => (
          <span
            key={key}
            className={own.demoKey}
            style={cssVar({ background: fingerFor(bundle, key)?.color })}
          >
            {key}
          </span>
        ))}
      </div>

      <p className={own.text} style={{ marginTop: 24 }}>
        Denk dran: Blick auf den <b>Bildschirm</b>, Finger in der Grundstellung – und{" "}
        <b>genau</b> ist besser als schnell!
      </p>
      <button type="button" className={styles.startButton} onClick={onStart}>
        Leertaste drücken zum Starten
      </button>
    </div>
  );
}
